import { render, staticRenderFns } from "./ApproveStatusModal.vue?vue&type=template&id=528df708&"
import script from "./ApproveStatusModal.vue?vue&type=script&lang=js&"
export * from "./ApproveStatusModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports